import React, {useState, useEffect} from 'react'
import '../../../../../../styles/kp-11Generic-catalog-card.css'
import {TextInput} from './kp-11Generic-catalog-card/customFields/TextInput'
import {NumberInput} from './kp-11Generic-catalog-card/customFields/NumberInput'
import {SelectInput} from './kp-11Generic-catalog-card/customFields/SelectInput'
import {CheckboxInput} from './kp-11Generic-catalog-card/customFields/CheckboxInput'
import {
  productEntitlementsFieldConfig,
  productOptionsFieldConfig,
  uiGroupProductFieldConfig,
} from './kp-11Generic-catalog-card/config'
export {parseResponseToUiGroups} from './kp-11Generic-catalog-card/utils'

export const GenericCatalogCard = ({
  name,
  icon,
  code,
  products = [],
  onProductSelection,
  onProductRemoval,
}) => {
  const [expanded, setExpanded] = useState(false)
  const [currentCartItemsToSend, setCurrentCartItemsToSend] = useState([])
  const [textInputValue, setTextInputValue] = useState('')
  const [isValid, setIsValid] = useState(false)

  const updateCart = (updatedCart, removedItem = null) => {
    setCurrentCartItemsToSend(updatedCart)
    console.log(`${name} This will be sended to the state:`, updatedCart)

    // If an item was removed, notify parent
    if (removedItem && onProductRemoval) {
      onProductRemoval(removedItem)
    }

    // Send raw products to parent - Redux cart building happens in catalog component
    if (onProductSelection) {
      onProductSelection(updatedCart)
    }
  }

  const handleSelectSubProduct = sub => {
    const isSelected = currentCartItemsToSend.some(
      item => item.code === sub.code,
    )

    if (isSelected) {
      // Deselect the item - pass it as removed
      const updatedCart = currentCartItemsToSend.filter(
        item => item.code !== sub.code,
      )
      updateCart(updatedCart, sub)
    } else {
      // Remove any excluded items and add the new selection
      const excludedItems = currentCartItemsToSend.filter(item =>
        sub.excludes?.includes(item.code),
      )
      const filtered = currentCartItemsToSend.filter(
        item => !sub.excludes?.includes(item.code),
      )
      const updatedCart = [...filtered, {...sub, entitlements: []}]
      // Notify about excluded items being removed
      excludedItems.forEach(excluded => {
        if (onProductRemoval) {
          onProductRemoval(excluded)
        }
      })
      updateCart(updatedCart)
    }
  }

  const handleToggleEntitlement = (parentCode, entitlement) => {
    const updatedCart = currentCartItemsToSend.map(item => {
      if (item.code === parentCode) {
        const isSelected = item.entitlements?.some(
          ent => ent.code === entitlement.code,
        )

        return {
          ...item,
          entitlements: isSelected
            ? item.entitlements.filter(ent => ent.code !== entitlement.code)
            : [...(item.entitlements || []), entitlement],
        }
      }
      return item
    })

    // Only update local state, don't trigger full onProductSelection
    // This avoids re-dispatching all items when just toggling an entitlement
    setCurrentCartItemsToSend(updatedCart)
    console.log(`${name} Entitlement toggled:`, updatedCart)
  }

  const isProductDisabled = sub => {
    return false // Allow all products to be selected
  }

  const isProductSelected = sub => {
    return currentCartItemsToSend.some(item => item.code === sub.code)
  }

  const isEntitlementSelected = (parentCode, entitlementCode) => {
    const parentItem = currentCartItemsToSend.find(
      item => item.code === parentCode,
    )
    return parentItem?.entitlements?.some(ent => ent.code === entitlementCode)
  }

  // Handler for updating entitlement values (text, number, select)
  const handleUpdateEntitlementValue = (parentCode, entitlement, value) => {
    const updatedCart = currentCartItemsToSend.map(item => {
      if (item.code === parentCode) {
        const existingEntitlementIndex = item.entitlements?.findIndex(
          ent => ent.code === entitlement.code,
        )

        if (
          existingEntitlementIndex !== undefined &&
          existingEntitlementIndex >= 0
        ) {
          // Update existing entitlement value
          const updatedEntitlements = [...item.entitlements]
          updatedEntitlements[existingEntitlementIndex] = {
            ...updatedEntitlements[existingEntitlementIndex],
            value,
          }
          return {...item, entitlements: updatedEntitlements}
        } else {
          // Add new entitlement with value
          return {
            ...item,
            entitlements: [
              ...(item.entitlements || []),
              {...entitlement, value},
            ],
          }
        }
      }
      return item
    })
    updateCart(updatedCart)
  }

  // Get entitlement value from cart
  const getEntitlementValue = (parentCode, entitlementCode) => {
    const parentItem = currentCartItemsToSend.find(
      item => item.code === parentCode,
    )
    const entitlement = parentItem?.entitlements?.find(
      ent => ent.code === entitlementCode,
    )
    return entitlement?.value
  }

  // Get all selected parent products to find entitlements
  // const selectedSubProducts = products.filter(sub => isProductSelected(sub))
  // const allEntitlements = selectedSubProducts.flatMap(
  //   sub => sub.entitlements || [],
  // )

  const hasSelectedItems = currentCartItemsToSend.length > 0

  const handleRemoveAll = () => {
    updateCart([])
  }

  // Remove all selected items if isValid becomes false
  useEffect(() => {
    if (!isValid && currentCartItemsToSend.length > 0) {
      handleRemoveAll()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid])

  // Helper function to render custom fields and entitlements based on configuration
  const renderProductCustomField = ({item, parentCode, fieldConfiguration}) => {
    // Extract config and label based on whether it's an entitlement or custom field
    console.log(fieldConfiguration, 'item.componentConfig')
    const componentType = fieldConfiguration?.type || 'checkbox'

    console.log(
      item,
      'config:',
      fieldConfiguration,
      'componentType:',
      componentType,
    )
    const currentValue = getEntitlementValue(parentCode, item.code)

    const handleChange = value => {
      handleUpdateEntitlementValue(parentCode, item, value)
    }

    if (componentType === 'text') {
      return (
        <TextInput
          config={fieldConfiguration}
          currentValue={currentValue}
          onChange={handleChange}
          placeholder={item.placeholder}
        />
      )
    }

    if (componentType === 'number') {
      return (
        <NumberInput
          config={fieldConfiguration}
          currentValue={currentValue}
          onChange={handleChange}
        />
      )
    }

    if (componentType === 'select') {
      return (
        <SelectInput
          config={fieldConfiguration}
          currentValue={currentValue}
          onChange={handleChange}
        />
      )
    }

    // Checkbox fallback for entitlements
    if (componentType === 'checkbox') {
      return (
        <CheckboxInput
          item={item}
          isChecked={isEntitlementSelected(parentCode, item.code)}
          onToggle={() => handleToggleEntitlement(parentCode, item)}
        />
      )
    }

    return null
  }

  const renderGenericCatalogCardCustomField = () => {
    const config = uiGroupProductFieldConfig[code]
    console.log(uiGroupProductFieldConfig, '💋💋💋', config)
    const placeholder = config.placeholder || 'Enter value'
    const componentType = config.type || 'text'
    const currentValue = textInputValue
    const handleChange = value => setTextInputValue(value)
    if (componentType === 'text') {
      return (
        <div style={{marginBottom: '8px'}}>
          <TextInput
            config={config}
            currentValue={currentValue}
            onChange={handleChange}
            placeholder={placeholder}
            setIsValid={setIsValid}
            isValid={isValid}
          />
        </div>
      )
    }
    if (componentType === 'number') {
      return (
        <div style={{marginBottom: '8px'}}>
          <NumberInput
            config={config}
            currentValue={currentValue}
            onChange={handleChange}
          />
        </div>
      )
    }
    if (componentType === 'select') {
      return (
        <div style={{marginBottom: '8px'}}>
          <SelectInput
            config={config}
            currentValue={currentValue}
            onChange={handleChange}
          />
        </div>
      )
    }
    return null
  }

  return (
    <div className="generic-catalog-card-container">
      <div
        className="catalog-card-header"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="card-heading">
          <div className="card-icon">
            <img src={icon} alt={name} className="options-logo rounded" />
          </div>
          <div className="card-title-text">{name}</div>
        </div>
        <div className="action-btn-wrap">
          {hasSelectedItems ? (
            <button
              className="action-btn remove-btn"
              onClick={e => {
                e.stopPropagation()
                handleRemoveAll()
              }}
            >
              Remove
            </button>
          ) : (
            <button className="action-btn add-btn">Add</button>
          )}
        </div>
      </div>
      {expanded && (
        <div className="catalog-card-body">
          {/* Render the product specific field config */}
          {uiGroupProductFieldConfig[code] &&
            renderGenericCatalogCardCustomField()}

          {/* Render products list only if the custom field (if any) is valid */}
          {(uiGroupProductFieldConfig[code] ? isValid : true) &&
            !!products.length && (
              <>
                <div
                  className="card-plan-item-wrap"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    marginBottom: '16px',
                  }}
                >
                  {products.map(sub => {
                    const disabled = isProductDisabled(sub)
                    const selected = isProductSelected(sub)

                    if (!selected) {
                      return (
                        <div key={sub.code}>
                          <div
                            className={`card-plan-item ${
                              disabled ? 'disabled' : ''
                            }`}
                            onClick={() =>
                              !disabled && handleSelectSubProduct(sub)
                            }
                            style={{
                              border: '2px solid transparent',
                              opacity: disabled ? 0.5 : 1,
                              cursor: disabled ? 'not-allowed' : 'pointer',
                              width: '100%',
                            }}
                          >
                            <div className="radio-btn">
                              <input
                                type="radio"
                                checked={false}
                                onChange={() =>
                                  !disabled && handleSelectSubProduct(sub)
                                }
                                disabled={disabled}
                              />
                            </div>
                            <div className="item-content-wrap">
                              <div className="plan-item-radio-label">
                                {sub.name}
                              </div>
                              <div className="plan-item-price">
                                ${sub.currencies?.[0]?.unitAmount}
                              </div>
                              <div className="plan-item-subtext">
                                {sub?.billingType || 'Billed Monthly'}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }

                    return (
                      <div key={sub.code}>
                        <div
                          className={`card-plan-item selected ${
                            disabled ? 'disabled' : ''
                          }`}
                          onClick={() =>
                            !disabled && handleSelectSubProduct(sub)
                          }
                          style={{
                            border: '2px solid #0066cc',
                            opacity: disabled ? 0.5 : 1,
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            width: '100%',
                          }}
                        >
                          <div className="radio-btn">
                            <input
                              type="radio"
                              checked={true}
                              onChange={() =>
                                !disabled && handleSelectSubProduct(sub)
                              }
                              disabled={disabled}
                            />
                          </div>
                          <div className="item-content-wrap">
                            <div className="plan-item-radio-label">
                              {sub.name}
                              {sub.code}
                            </div>
                            <div className="plan-item-price">
                              ${sub.currencies?.[0]?.unitAmount}
                            </div>
                            <div className="plan-item-subtext">
                              {sub?.billingType || 'Billed Monthly'}
                            </div>
                          </div>
                        </div>

                        {(productOptionsFieldConfig?.[sub.code] ||
                          sub.entitlements?.length > 0) && (
                          <>
                            <div
                              className="card-plan-subText"
                              style={{marginBlock: '8px', fontWeight: '700'}}
                            >
                              Options
                            </div>
                            <div
                              style={{
                                marginTop: '12px',
                                marginLeft: '16px',
                                paddingLeft: '16px',
                                paddingTop: '8px',
                                paddingBottom: '4px',
                                borderLeft: '2px solid #0066cc',
                              }}
                            >
                              {/* Render product specific field configuration */}
                              {productOptionsFieldConfig?.[sub.code] &&
                                renderProductCustomField({
                                  item: sub,
                                  parentCode: sub.code,
                                  fieldConfiguration:
                                    productOptionsFieldConfig[sub.code],
                                })}
                              {/* Render options (entitlements) under selected product */}
                              {sub.entitlements?.length > 0 && (
                                <>
                                  {/* Render entitlements */}
                                  {sub.entitlements.map(entitlement => (
                                    <div key={entitlement.code}>
                                      {renderProductCustomField({
                                        item: entitlement,
                                        parentCode: sub.code,
                                        fieldConfiguration:
                                          productEntitlementsFieldConfig[
                                            entitlement.code
                                          ],
                                      })}
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )
                  })}
                </div>
              </>
            )}
        </div>
      )}
    </div>
  )
}
